"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MusicItem = (function (_super) {
    __extends(MusicItem, _super);
    function MusicItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            images: props.images,
        };
        return _this;
    }
    MusicItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, subtitle = _a.subtitle, url = _a.url;
        var images = this.state.images;
        var image = images[0], rest = images.slice(1);
        var onError = function () {
            if (rest.length)
                _this.setState({ images: rest });
        };
        return (react_1.default.createElement("article", { className: "col-3 col-6-xsmall work-item" },
            react_1.default.createElement("a", { className: "image fit thumb", style: { cursor: 'pointer', outline: '0px' }, href: url },
                react_1.default.createElement("img", { src: image, alt: title, onError: onError })),
            react_1.default.createElement("h3", null, title),
            subtitle ? react_1.default.createElement("p", null, subtitle) : null));
    };
    return MusicItem;
}(react_1.default.Component));
exports.default = MusicItem;
